export interface InputOptions {
  labelText: string;
  placeholder?: string;
  type: string;
}
